module.exports = __webpack_public_path__ + "img/arrows-in-circle.967452ec.svg";